module.exports = __webpack_public_path__ + "static/media/wx.006c0914.png";